/* eslint-disable max-len */
import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import * as types from "~/store/news/newsType";
import * as api from "~/store/news/newsApi";
import { ceil } from "lodash-es";
import { apiNews, LIMIT_PAGE_NEWS } from "~/utils/constants";

function* getTotalListNews() {
  try {
    const url_umcmono = apiNews + `/posts?&partners=umcmono`;
    const url_umc1 = apiNews + `/posts?&partners=umc1`;
    const rs_umcmono = yield call(api.countData, url_umcmono);
    const rs_umc1 = yield call(api.countData, url_umc1);
    const total_rs = rs_umcmono.concat(rs_umc1);
    const sumPage = ceil(total_rs / LIMIT_PAGE_NEWS);

    yield put({ type: types.COUNT_LIST_NEWS_SUCCESS, totalData: sumPage });
  } catch (error) {
    console.log("error umc :>> ", error);
  }
}
function* watchGetTotalListNews() {
  yield takeLatest(types.GET_TOTAL_LIST_NEWS, getTotalListNews);
}

function* getListNews({ page = 1 }) {
  try {
    const start = +page === 1 ? 0 : (+page - 1) * LIMIT_PAGE_NEWS;
    const url_umcmono =
      apiNews +
      `/posts?&_start=${start}&_limit=${LIMIT_PAGE_NEWS}&partners=umcmono&_sort=updated_at:desc`;
    const url_umc1 =
      apiNews +
      `/posts?&_start=${start}&_limit=${LIMIT_PAGE_NEWS}&partners=umc1&_sort=updated_at:desc`;
    const rs_umcmono = yield call(api.getData, url_umcmono);
    const rs_umc1 = yield call(api.getData, url_umc1);
    yield put({
      type: types.LIST_NEWS_SUCCESS,
      listNews: rs_umcmono.concat(rs_umc1)
    });
  } catch (error) {
    console.log("error:>> ", error);
    yield put({ type: types.LIST_NEWS_SUCCESS, listNews: [] });
  }
}
function* watchGetListNews() {
  yield takeLatest(types.GET_LIST_NEWS, getListNews);
}

function* getGetListNewsBanner() {
  try {
    const url_umcmono = `https://cms.medpro.com.vn/posts?_sort=updated_at:DESC&partners=umcmono`;
    const url_umc1 = `https://cms.medpro.com.vn/posts?_sort=updated_at:DESC&partners=umc1`;
    const rs_umcmono = yield call(api.getListNewsBanner, url_umcmono);
    const rs_umc1 = yield call(api.getListNewsBanner, url_umc1);

    yield put({
      type: types.LIST_NEWS_BANNERS_SUCCESS,
      listNewsBanner: rs_umcmono.concat(rs_umc1)
    });
  } catch (error) {
    console.log("error :>> ", error);
    yield put({ type: types.LIST_NEWS_BANNERS_SUCCESS, listNewsBanner: [] });
  }
}
function* watchGetListNewsBanner() {
  yield takeLatest(types.LIST_NEWS_BANNERS, getGetListNewsBanner);
}

export default function* root() {
  yield all([
    fork(watchGetTotalListNews),
    fork(watchGetListNews),
    fork(watchGetListNewsBanner)
  ]);
}
